import React from "react";

import { AW23 } from "../../../../js/database/database-aw23-eshop.js";

import ProductsContainer from "../../../../components/containers/ProductsContainer.js";
import { SwiperSlide } from "swiper/react";

const StonewashedBeltedCombatPants = () => {
  return (
    <ProductsContainer
      pageTitle={AW23.pants.StonewashedBeltedCombatPants.itemName}
      name={AW23.pants.StonewashedBeltedCombatPants.itemName}
      price={AW23.pants.StonewashedBeltedCombatPants.itemPrice}
      fabric={AW23.pants.StonewashedBeltedCombatPants.itemFabric}
      src={AW23.pants.StonewashedBeltedCombatPants.sizeChart}
      divId={AW23.pants.StonewashedBeltedCombatPants.shopifyDivId}
      mainId={AW23.pants.StonewashedBeltedCombatPants.shopifyId}
      buttonShouldHide={true}
    >
      {React.Children.toArray(
        AW23.pants.StonewashedBeltedCombatPants.pictures.map(({ srcJpeg }) => (
          <SwiperSlide>
            <img
              src={srcJpeg}
              alt={AW23.pants.StonewashedBeltedCombatPants.itemName}
              width={AW23.imgWidth}
              height={AW23.imgHeight}
              loading={AW23.loading}
            />
          </SwiperSlide>
        ))
      )}
    </ProductsContainer>
  );
};

export default StonewashedBeltedCombatPants;
